<template>
  <b-form-group
    label="Sözleşme Bitiş Tarihi"
    label-for="edate"
  >
    <b-form-datepicker
      id="edate"
      v-model="dataItem.tenants.edate"
      v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
      locale="tr"
      start-weekday="1"
      :disabled="isDisabled"
    />
  </b-form-group>
</template>
<script>
import { BFormGroup, BFormDatepicker } from 'bootstrap-vue'

export default {
  name: 'TenantEnd',
  components: {
    BFormDatepicker,
    BFormGroup,
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dataItem() {
      return this.$store.getters['estates/dataItem']
    },
  },
}
</script>
